// extracted by mini-css-extract-plugin
export default {"chartInfoContainer":"ChartInfo_chartInfoContainer__5m0Bf","rangesWrapper":"ChartInfo_rangesWrapper__JDJKp","chartInfoBorder":"ChartInfo_chartInfoBorder__bigrp"};